import { render, staticRenderFns } from "./RightSidebar.vue?vue&type=template&id=47adf4ca&scoped=true"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"
import style0 from "./RightSidebar.vue?vue&type=style&index=0&id=47adf4ca&prod&scoped=true&lang=css"
import style1 from "./RightSidebar.vue?vue&type=style&index=1&id=47adf4ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47adf4ca",
  null
  
)

export default component.exports